<template>
  <v-app>
    <component :is="layout" :class="$route.meta.className">
      <router-view />
    </component>

    <v-btn
      v-scroll="onScroll"
      v-show="fab"
      fab
      dark
      fixed
      bottom
      small
      right
      class="custom-main-btn"
      @click="toTop"
    >
      <i class="fal fa-angle-up fa-2x"></i>
    </v-btn>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data: () => ({
    fab: false
  }),
  computed: {
    layout() {
      const layout = this.$route.meta.layout || 'default'
      return () => import(`@/layouts/${layout}.vue`)
    }
  },
  methods: {
    ...mapActions(['fetchAboutUsMenuPages', 'fetchAppSettings', 'fetchUser']),
    onScroll(e) {
      if (typeof window === 'undefined') return
      const top = window.pageYOffset || e.target.scrollTop || 0
      this.fab = top > 50
    },
    toTop() {
      this.$vuetify.goTo(0)
    }
  },
  created() {
    this.fetchUser()
    this.fetchAboutUsMenuPages()
    this.fetchAppSettings()
  }
}
</script>
